/**
 * Прокручивает только что раскрытый столбец в свободную область между
 * закреплёнными зонами таблицы. Sticky-классы есть и у data-колонок, и у
 * служебных треков (выбор, действия, разворот), поэтому геометрия учитывает оба
 * вида без знания конфигурации DataTable.
 */
export const scrollToColumn = (root: HTMLElement | null, field: string) => {
    const scroll = root?.querySelector<HTMLElement>('.dtb__scroll');
    const cell = root?.querySelector<HTMLElement>(`[data-head-col="${CSS.escape(field)}"]`);
    if (!scroll || !cell) return;

    // Закреплённая цель уже находится у края viewport. Попытка прокрутить её
    // исходную позицию только уводит остальные данные в неожиданное место.
    if (cell.matches('.dtb__stick-l, .dtb__stick-r')) return;

    const scrollRect = scroll.getBoundingClientRect();
    const head = cell.closest<HTMLElement>('.dtb__head');
    const pinned = head?.querySelectorAll<HTMLElement>('.dtb__stick-l, .dtb__stick-r') ?? [];
    let visibleLeft = scrollRect.left;
    let visibleRight = scrollRect.right;
    pinned.forEach((element) => {
        const rect = element.getBoundingClientRect();
        if (element.classList.contains('dtb__stick-l')) visibleLeft = Math.max(visibleLeft, rect.right);
        if (element.classList.contains('dtb__stick-r')) visibleRight = Math.min(visibleRight, rect.left);
    });

    const gap = 12;
    visibleLeft += gap;
    visibleRight -= gap;
    if (visibleRight <= visibleLeft) return;

    const cellRect = cell.getBoundingClientRect();
    const availableWidth = visibleRight - visibleLeft;
    const cellWidth = cellRect.right - cellRect.left;
    let delta = 0;
    // Очень широкий столбец показываем с начала; обычный — минимальным сдвигом,
    // как inline: nearest, но в viewport без перекрытия sticky-зонами.
    if (cellWidth > availableWidth) delta = cellRect.left - visibleLeft;
    else if (cellRect.left < visibleLeft) delta = cellRect.left - visibleLeft;
    else if (cellRect.right > visibleRight) delta = cellRect.right - visibleRight;
    if (Math.abs(delta) < 1) return;

    const left = Math.max(0, scroll.scrollLeft + delta);
    // scrollTo есть не везде (jsdom, старые webview) — прокрутка не тот повод,
    // чтобы уронить таблицу необработанным исключением.
    if (typeof scroll.scrollTo === 'function') scroll.scrollTo({ left, behavior: 'smooth' });
    else scroll.scrollLeft = left;
};
